<div class="cs">
  <div class="cs-head">
    <div class="cs-title">{{ statement?.report }}</div>
    <div class="cs-sub">
      <span *ngIf="statement?.organisation">{{ statement.organisation }}</span>
      <span *ngIf="statement?.organisation && periodLabels.length"> · </span>
      <span>{{ periodLabels[0] }}</span>
      <span *ngIf="statement?.basis" class="cs-basis"> · {{ statement.basis }}</span>
    </div>
  </div>

  <div class="cs-scroll">
    <table class="cs-table">
      <thead *ngIf="periodLabels.length > 1">
        <tr>
          <th></th>
          <th *ngFor="let p of periodLabels" class="cs-num">{{ p }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of rows; let i = index; trackBy: trackRow">
          <tr *ngIf="visible(row, i)" [ngClass]="'cs-row cs-row--' + row.kind">
            <td class="cs-label" [attr.colspan]="row.kind === 'section' ? periodLabels.length + 1 : null">{{ row.label }}</td>
            <ng-container *ngIf="row.kind !== 'section'">
              <td *ngFor="let p of periodLabels; let pi = index" class="cs-num">{{ money(row.amounts[pi]) }}</td>
            </ng-container>
          </tr>
          <tr *ngIf="visible(row, i) && moreAfter(row, i) as more" class="cs-row cs-row--more">
            <td [attr.colspan]="periodLabels.length + 1">
              <button type="button" class="cs-more" (click)="expand(row.groupKey)">Show {{ more }} more</button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="cs-foot">
    <span *ngFor="let n of statement?.notes" class="cs-note">{{ n }}</span>
    <a *ngIf="isProfitAndLoss" class="cs-open" href="/report/profit-loss-report" target="_blank" rel="noopener">Open in Reports</a>
  </div>
</div>
